/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47818Req {
  
  /** 项目编号 */
  projectNo?: string;
  /** 汇报日期,yyyy-MM-dd */
  reportDate?: any;
  /** 内容 */
  content?: string;
  /** 健康标志：0-10 */
  healthFlag?: number;
  /** 项目进度,double值，61.23%为61.23 */
  projectProgressDou?: number;
};



export type API47818Res = {};


// 47818 添加项目汇报

export interface IUsePostAPI47818Return {
  /** 添加项目汇报: 接口请求状态 */
  isAPI47818Loading: boolean;
  /** 添加项目汇报: 接口请求返回数据 */
  dataAPI47818: API47818Res;
  /**  添加项目汇报: 接口数据请求方法 */
  fetchAPI47818Data:  (inputs: API47818Req, config?: YWRequestConfig) => Promise<API47818Res>;
  /** 添加项目汇报: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47818 = ():IUsePostAPI47818Return => {
  let isMount = true;
  const [isAPI47818Loading, setIsAPI47818Loading] = useState(false);
  const [dataAPI47818, setDataAPI47818] = useState<API47818Res>({} as API47818Res);
  const requestUrl = `${basePath}/corp-admin/project/report/add`;

  const fetchAPI47818Data = async (inputs: API47818Req, config?: YWRequestConfig): Promise<API47818Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47818Req>) || {}) as API47818Req;
    
  
    if ( isMount ) {
      setIsAPI47818Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47818Res>(`${basePath}/corp-admin/project/report/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47818(res || {} as API47818Res);
        setIsAPI47818Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47818Loading(false);
      }
      return false as unknown as API47818Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47818Loading,
    dataAPI47818,
    fetchAPI47818Data,
    requestUrl,
  }
}

